exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recipient-tags {\n  display: none;\n}\n.ant-select-selection--multiple {\n  min-height: 30px;\n}\n.email-info {\n  max-width: 100%;\n}", ""]);

// exports
